import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ActiveDirectoryService {

    constructor(private http: HttpClient) { }

    updateActiveDirectoryConfig(body: any): Observable<any> {
        return this.http.post(environment.updateActiveDirectoryConfig, body);
    }

    createActiveDirectoryConfig(body: any): Observable<any> {
        return this.http.post(environment.createActiveDirectoryConfig, body);
    }

    getActiveDirectoryConfig(body: any): Observable<any> {
        return this.http.post(environment.getActiveDirectoryConfig, body);
    }

    deleteActiveDirectoryConfig(body: any): Observable<any> {
        return this.http.post(environment.deleteActiveDirectoryConfig, body);
    }
    
}
